import { useCallback, useState } from "react";
import debounce from "lodash.debounce";
import { findMaxSecondMarker } from "../../../../helpers";

export const useTimelineFilter = ({
  initialRange = { min: 0, max: 90 },
  debounceMs = 500,
} = {}) => {
  const [timeLineRange, setTimeLineRange] = useState(initialRange);

  const getDebouncedTimelineHandler = useCallback(
    ({ getEvents, setDisplayedEvents }) => {
      return debounce(({ min, max }) => {
        const sourceEvents = getEvents?.() || [];

        if (sourceEvents?.length === 0) {
          setDisplayedEvents([]);
          return;
        }

        const filteredEvents = sourceEvents.filter(
          (item) => +item.second >= min * 60 && +item.second <= max * 60
        );

        setDisplayedEvents(filteredEvents);
      }, debounceMs);
    },
    [debounceMs]
  );

  const updateRangeFromEvents = useCallback(
    (events, fallbackMaxSeconds = 0) => {
      let maxSecond = findMaxSecondMarker(events || []);

      if (!maxSecond && fallbackMaxSeconds > 0) {
        maxSecond = fallbackMaxSeconds;
      }

      const nextMax = Math.ceil(+maxSecond / 60 / 5) * 5;
      const maxToApply = nextMax > 0 ? nextMax : initialRange.max;

      setTimeLineRange({ min: 0, max: maxToApply });

      return maxToApply;
    },
    [initialRange.max]
  );

  const resetTimeline = useCallback(() => {
    setTimeLineRange(initialRange);
  }, [initialRange]);

  return {
    timeLineRange,
    setTimeLineRange,
    getDebouncedTimelineHandler,
    updateRangeFromEvents,
    resetTimeline,
  };
};

export default useTimelineFilter;
